import React from 'react';

import type { SectionHeadingProps } from './SectionHeading.types';

import styles from './SectionHeading.module.scss';

const SectionHeading: React.FC<SectionHeadingProps> = ({ heading, preheading }) => (
	<div className={styles.headings}>
		{preheading && <h2 className={styles.preheading}>{preheading}</h2>}
		{heading && <h3 className={styles.heading}>{heading}</h3>}
	</div>
);

export default SectionHeading;
